/* eslint-disable @typescript-eslint/no-deprecated */
/**
 * @module ParseEmoteInput
 * Last updated 3/26/25
 * Added export default to end of file; update _apiUrl to work w/app.mfc
 * Added darkMode support (Kiran 3/26/25)
 */
import { palette } from '../../components/styles/colors'
import { PAPER_HEIGHTS } from '../../components/theme'
import Emoji from '../../mfcLogic/emoji'

/* 
  eslint-disable fp/no-let, fp/no-loops, no-empty, no-var,
  no-undef, eqeqeq, no-redeclare, no-useless-escape, no-unused-vars,
  @typescript-eslint/no-unused-vars, @typescript-eslint/no-this-alias
*/

const d = (...args) => console.log(...args)

//
// Necessary for image urls to work when send in the room
//
const IMAGE_MESSAGE_BASE_DOMAIN = 'https://www.myfreecams.com'
const EMOTE_IMAGE_URL = 'https://img.mf' + 'cimg.com/'

/**
 * Necessary for the preview to display correctly; Customized to look/feel like MFC APP
 * @param {*} div - target div
 * @param {*} anchor - 'top' or 'bottom', depending on <Compose /> location
 */
const applyCustomPreviewDivStyles = (div, anchor) => {
    div.style.backgroundColor = palette.drawerBackground
    div.style.borderRadius = '4px'
    div.style.border = `1px solid ${palette.drawerDivider}`
    div.style.boxShadow = `0px 0px 3px 1px ${palette.dialogButtonShadows}`
    div.style.maxHeight = '200px'
    div.style.overflow = 'auto'
    if (anchor === 'bottom') {
        div.style.top = '25px'
        div.style.zIndex = PAPER_HEIGHTS.dialog
    } else {
        div.style.bottom = '40px'
    }
    div.style.maxWidth = '380px'
}

// Necessary for the preview to display correctly
const formatImageElement = (url) =>
    '<div class="inlineEmotePreview_item primary">' +
    '<img style="vertical-align: middle" src="' +
    url +
    '"/>' +
    '</div>'

/**
 *  @fileoverview
 *  @suppress {duplicate|checkTypes|checkVars|invalidCasts}
 */

// ajax cross subdomain requirement
try {
    document.domain = document.domain.replace(/.*?(\w+\.\w+)$/, '$1')
} catch (e) {}

/*
 ParseEmoteInput - Object for converting input streams into a mixed array
 of text and image data for formatting as output or sending to a chat server

 Dependencies:

  MfcJSON.js - JSON Parser
  MfcUtilities.js - Ajax helper functions


 Usage:

  var parseInput = new ParseEmoteInput();

  function myCallback(sParsedString, aMsg)
  {
	  // Loop through array aMsg2[] for results of processed input,
	  // or just use sParsedString if we are happy with the default parsing and img tagging

	  document.getElementById('somediv').innerHTML = sParsedString;
  }

  // sInput should be a string of user input that might contain a :shortcut
  // myCallback can be null, but only if you don't want to process any
  // unmatched codes (user chat images that aren't cached)

  parseInput.Process(sInput, myCallback);

*/

/**
 * @constructor
 */
function ParseEmoteInput(options) {
    ParseEmoteInput.counter = parseInt(ParseEmoteInput.counter) + 1
    this.counter = ParseEmoteInput.counter
    ParseEmoteInput.register[ParseEmoteInput.counter] = this

    this.apiUrl =
        /* ( MfcClientRes && MfcClientRes.apiUrl ) || */ '//api-edge.' +
        document.domain.replace(/.*?(\w+\.\w+)$/, '$1')
    this.inlineEmotePreview_req = null

    this.oReq = this.createRequestObject()
    this.Reset()

    this.nImageRateLimit = 0
    this.oImageRateLimit_Timer = null

    // property to pass `setMessage` from <Compose /> as callback
    this.setComposeMessage = options && options.setComposeMessage
    this.oAnchor = options && options.anchor
    this.bDarkMode = options && options.darkMode

    this.image_url = (options && options.image_url) || EMOTE_IMAGE_URL
}
ParseEmoteInput.register = {}
ParseEmoteInput.counter = 0

ParseEmoteInput.prototype.createRequestObject = function () {
    var xhr
    if (window.navigator.appName.indexOf('Internet Explorer') > -1) {
        xhr = new ActiveXObject('Microsoft.XMLHTTP')
    } else {
        xhr = new XMLHttpRequest()
        xhr.withCredentials = true
    }

    return xhr
}

ParseEmoteInput.prototype.Reset = function () {
    this.sParsedString = ''
    this.sPost = ''
    this.aMsg1 = [] // Pre-processed string (broken into text and image shortcuts)
    this.aMsg2 = [] // Post-processed string (broken into text and image objects)
    this.bDone = false
    this.callbackFunc = null
}

ParseEmoteInput.prototype.Process = function (sInp, fpCallback) {
    var nFound = 0

    this.Reset()

    this.callbackFunc = fpCallback

    sInp = sInp.replace(/#~[^~]*~#/g, '')
    sInp = sInp.replace(/"/g, '&quot;')

    // Create pre-processed array of chunks based on input string
    this.DecodeInput(sInp)

    // Build ajax request (of aMsg1) or html equiv (if no unmatched images are found)
    for (var nCx = 0; nCx < this.aMsg1.length; nCx++) {
        if (typeof this.aMsg1[nCx]['val'] == 'string')
            this.aMsg1[nCx]['val'] = this.aMsg1[nCx]['val'].replace(
                'reverse_smilyface',
                '(:',
            )

        if (typeof this.aMsg1[nCx] == 'object') {
            this.sPost +=
                'a' +
                nCx +
                '=' +
                encodeURIComponent(this.aMsg1[nCx]['val']) +
                '&'

            // If shortcut is found, and we dont have any unmatched shortcuts so far
            var oStandardEmote
            if (
                ((oStandardEmote =
                    this.m_hEmoticonMap[
                        ':' + this.aMsg1[nCx]['val'].toLowerCase()
                    ]) != null ||
                    (oStandardEmote =
                        this.m_hEmoticonMap[
                            this.aMsg1[nCx]['val'].toLowerCase()
                        ]) != null) &&
                nFound == 0
            ) {
                var sDark = this.bDarkMode ? 'dark/' : ''
                var sUrl =
                    this.image_url +
                    'chat_images/e/' +
                    sDark +
                    oStandardEmote['id'] +
                    '.gif'

                var obj = {}
                obj['txt'] = this.aMsg1[nCx]['val']
                obj['url'] = sUrl
                obj['code'] =
                    '#~e,' +
                    oStandardEmote['id'] +
                    ',' +
                    this.aMsg1[nCx]['val'] +
                    ',' +
                    oStandardEmote['width'] +
                    ',' +
                    oStandardEmote['height'] +
                    '~#'
                //obj['code'] = "#~e," + oStandardEmote['id'] + "," + this.aMsg1[nCx]['val'] + "~#";

                this.aMsg2.push(obj)
                this.sParsedString += obj['code']
                //this.sParsedString += "<img src=" + sUrl + ">";
            } else if (this.aMsg1[nCx]['val'].match(/^\w+\.\w{3}$/)) {
                var obj = {}
                obj['txt'] = this.aMsg1[nCx]['val']
                obj['code'] = '#~c,' + this.aMsg1[nCx]['val'] + ',www~#'

                this.aMsg2.push(obj)
                this.sParsedString += obj['code']
            } else {
                // Unmatched images, now it's up to ajax to figure stuff out for us
                nFound++
            }
        } else {
            this.sPost +=
                't' + nCx + '=' + encodeURIComponent(this.aMsg1[nCx]) + '&'
            if (nFound == 0) {
                this.sParsedString += this.aMsg1[nCx]
                this.aMsg2.push(this.aMsg1[nCx])
            }
        }
    }

    if (nFound == 0) {
        // No post-processing needed
        this.bDone = true

        if (this.callbackFunc) this.callbackFunc(this.sParsedString, this.aMsg2)
    } else {
        // Reset the array to be created instead by ajax response
        this.aMsg2 = []

        // ajax call to create post-processed array of chunks
        this.AjaxSend()
    }

    return this.bDone
}

// Extract http:// image urls from input, and pass input stream left and right of http img
// to SplitInput for shortcut processing

ParseEmoteInput.prototype.DecodeInput = function (sVal) {
    var sBefore = '',
        sMatch = '',
        sAfter = ''

    // Replace any ;) emotes (special case) with :;) for standard matching
    sVal = sVal.replace('(:', ':reverse_smilyface')
    if (!sVal.match(/http[s]?:/)) {
        var aEmoteColonExceptions = [';)', '8D', '=o/', '8)', '=;', '=]']
        for (var n = 0; n < aEmoteColonExceptions.length; n++)
            sVal = sVal.replace(
                aEmoteColonExceptions[n],
                ':' + aEmoteColonExceptions[n],
            )
    }

    // First extract any image post URLs so they aren't confused with shortcuts
    var re = []
    if ((re = sVal.match(/^(.*?)(http[s]?:\/\/\S+)(.*)$/))) {
        sBefore = re[1]
        sMatch = re[2]
        sAfter = re[3]
    } else {
        sBefore = sVal
    }

    // SplitInput on left-side
    this.SplitInput(sBefore)

    /*
	// add http image object to this.aMsg1[] if it appears to be an image
	if( sMatch.match(/^https:\/\/(share\.myfreecams\.com|www\.youtube\.com|www\.instagram\.com|[w\.]*twitter\.com)\//i) )
	{
		this.aMsg1.push({'val': sMatch});
	}
	// add http image object to this.aMsg1[] if it appears to be an image
	else
*/
    if (
        sMatch.match(/\.(gif|jpeg|jpg|png)$/i) ||
        sMatch.match(/\.(gif|jpeg|jpg|png)\?\S*$/i)
    ) {
        this.aMsg1.push({ val: sMatch })
    } else if (sMatch) {
        this.aMsg1.push(sMatch)
    }

    // SplitInput on right-side
    if (sAfter) this.SplitInput(sAfter)
}

// SplitInput - takes part (or all) of an input string and breaks it up, adding each chunk to this.aMsg1[]
// Do not call this with input containing http:// img urls, they should be extracted first in DecodeInput

ParseEmoteInput.prototype.SplitInput = function (sVal) {
    var nPos = 0,
        nIdx,
        nLen = sVal.length
    var sTmp

    while (nPos < nLen) {
        sTmp = sVal.substring(nPos)

        if (!sTmp.match(/:[\.\w\-\);\(=\?\*$]/)) {
            this.aMsg1.push(sTmp)
            nPos = nLen
        } else {
            nIdx = sTmp.indexOf(':')

            if (nIdx > 0) this.aMsg1.push(sTmp.substring(0, nIdx))

            var nTmpPos = nIdx + 1,
                nTmpLen = sTmp.length
            while (nTmpPos < nTmpLen) {
                var ch = sTmp.charAt(nTmpPos)
                if (
                    ch == ' ' ||
                    ch == '\t' ||
                    ch == '\n' ||
                    ch == '\r' ||
                    ch == ':'
                )
                    break
                nTmpPos++
            }

            var nCodeLen = nTmpPos - nIdx
            if (nCodeLen > 0) {
                var sCode = sTmp.substring(nIdx + 1, nTmpPos)

                // All digits? not a shortcut
                if (
                    /\D/.test(sCode) == false &&
                    nIdx > 0 &&
                    /\D/.test(sTmp.charAt(nIdx - 1)) == false
                )
                    this.aMsg1.push(':' + sCode)
                else this.aMsg1.push({ val: sCode })
            }

            nPos += nIdx + nCodeLen
        }
    }
}

ParseEmoteInput.prototype.setUrl = function (url) {
    this.sUrl = url
}

ParseEmoteInput.prototype.getUrl = function (sPost) {
    sPost = sPost || ''

    if (this.sUrl) {
        return this.sUrl
    }

    var sRequest = ''
    // send inline chat images to www php
    if (document.location.protocol == 'file:' || sPost.indexOf('http') > -1) {
        //sRequest = "//www." + document.domain.replace(/.*?(\w+\.\w+)$/,"$1") + "/php/ParseChatStream.php";
        sRequest = IMAGE_MESSAGE_BASE_DOMAIN + '/php/ParseChatStream.php'
    } else {
        sRequest = this.apiUrl + '/parseEmote'
    }

    return sRequest
}

ParseEmoteInput.prototype.AjaxSend = function () {
    var sRequest =
        this.getUrl(this.sPost) + '?' + this.sPost + '&' + Math.random()

    this.oReq.open('get', sRequest)
    var self = this
    this.oReq.onreadystatechange = function () {
        self.AjaxResponse()
    }
    this.oReq.send(null)
}

ParseEmoteInput.prototype.Reset_ImageRateLimit = function () {
    this.nImageRateLimit = 0
}

ParseEmoteInput.prototype.AjaxResponse = function () {
    if (this.oReq.readyState != 4) return

    var self = this
    this.oImageRateLimit_Timer = setTimeout(function () {
        self.Reset_ImageRateLimit()
    }, 60000)

    this.aMsg2 = []
    this.sParsedString = ''

    try {
        this.aMsg2 = JSON.parse(this.oReq.responseText)

        if (this.aMsg2.result) {
            this.aMsg2 = this.aMsg2.result
        }
    } catch (e) {
        this.aMsg2[0] = {
            err: 1,
            txt: 'error_invalid_image',
            code: '#~e,1000,error_invalid_image~#',
        }
    }

    if (this.aMsg2) {
        for (var n = 0; n < this.aMsg2.length; n++) {
            if (typeof this.aMsg2[n] == 'object') {
                this.nImageRateLimit++

                if (this.nImageRateLimit > 9) {
                    this.aMsg2[n]['code'] =
                        '#~e,1000,too_many_images_posted_in_a_short_period_of_time~#'
                } else if (this.aMsg2[n]['err']) {
                    if (this.aMsg2[n]['txt'].indexOf('error_') == -1) {
                        this.aMsg2[n]['code'] = this.aMsg2[n]['txt']
                    } else {
                        this.aMsg2[n]['code'] =
                            '#~e,1000,' + this.aMsg2[n]['txt'] + '~#'
                    }
                }

                /*
				if (this.aMsg2[n].url.indexOf("chat_images") != -1)
					this.aMsg2[n].url = this.aMsg2[n].url.replace(".", ".x50.");

				this.sParsedString += "<img src=" + this.aMsg2[n].url + " alt=\"" + this.aMsg2[n]['txt'] + "\" title=\"" + this.aMsg2[n]['txt'] + "\">";
				*/

                this.sParsedString += this.aMsg2[n]['code'] || ''
            } else {
                this.sParsedString += this.aMsg2[n]
            }
        }
    } else {
        // alert('Invalid return from ajax parse');
    }

    this.bDone = true

    if (this.callbackFunc) this.callbackFunc(this.sParsedString, this.aMsg2)
}

ParseEmoteInput.prototype.m_hEmoticonMap = Emoji

ParseEmoteInput.prototype.inlineEmotePreview = function (hOptions) {
    hOptions = hOptions || this.inlineEmotePreview_hOptions || {}

    this.inlineEmotePreview_hOptions = hOptions

    if (hOptions.callback) {
        this.inlineEmotePreview_client_callback = hOptions.callback
    }
    if (hOptions.input) {
        this.oTextInput = hOptions.input
    }

    var sText = hOptions.input.value

    if (sText && sText.match(/:(\S+)$/)) {
        if (!this.inlineEmotePreview_timerPermit) {
            var self = this

            if (this.inlineEmotePreview_timer) {
                clearTimeout(this.inlineEmotePreview_timer)
            }
            this.inlineEmotePreview_timer = setTimeout(function () {
                self.inlineEmotePreview_timerPermit = true
                self.inlineEmotePreview(hOptions)
            }, 700)

            if (this.inlineEmotePreview_timer2) {
                clearTimeout(this.inlineEmotePreview_timer2)
            }
            this.inlineEmotePreview_timer2 = setTimeout(function () {
                self.inlineEmotePreview_timerPermit = false
            }, 5000)

            return
        }

        var hImage
        var sDark = this.bDarkMode ? 'dark/' : ''
        if (
            (hImage = ParseEmoteInput.prototype.m_hEmoticonMap[':' + RegExp.$1])
        ) {
            hImage.url =
                this.image_url + 'chat_images/e/' + sDark + hImage.id + '.gif'
            hImage.shortcut = RegExp.$1
            if (this.inlineEmotePreview_client_callback) {
                this.inlineEmotePreview_client_callback(hImage)
            }
        } else if (sText.match(/:(\w+)$/) && hOptions.access_level > 1) {
            var url =
                this.apiUrl +
                '/user_chat_images/' +
                RegExp.$1 +
                '?return_partials=1'

            var self = this
            this.abortInlineEmotePreviewLookup()
            this.inlineEmotePreview_req = new XMLHttpRequest()
            this.inlineEmotePreview_req.open('get', url)
            this.inlineEmotePreview_req.onreadystatechange = function () {
                self.inlineEmotePreview_callback()
            }
            this.inlineEmotePreview_req.send(null)
        }
    } else if (this.inlineEmotePreview_client_callback) {
        this.inlineEmotePreview_timerPermit = false
        this.inlineEmotePreview_client_callback()
    }
}

ParseEmoteInput.prototype.abortInlineEmotePreviewLookup = function () {
    if (
        this.inlineEmotePreview_req &&
        typeof this.inlineEmotePreview_req.abort === 'function'
    ) {
        this.inlineEmotePreview_req.onreadystatechange = null
        this.inlineEmotePreview_req.abort()
    }
}

ParseEmoteInput.prototype.inlineEmotePreview_callback = function () {
    if (this.inlineEmotePreview_req.readyState !== 4) {
        return
    }

    var oRes = JSON.parse(this.inlineEmotePreview_req.responseText)

    if (!oRes || !oRes['result']) {
        return
    }

    var hImage = oRes['result']

    if (hImage['hex_crc32'] || hImage['partials']) {
        if (hImage['hex_crc32']) {
            hImage.url =
                this.image_url +
                'chat_images/u/' +
                hImage['hex_crc32'].substring(0, 2) +
                '/' +
                hImage['hex_crc32'] +
                '.' +
                hImage['format']
        }

        if (this.inlineEmotePreview_client_callback) {
            this.inlineEmotePreview_client_callback(hImage)
        }
    } else if (this.inlineEmotePreview_client_callback) {
        this.inlineEmotePreview_client_callback()
    }
}

ParseEmoteInput.prototype.inlineEmotePreview_close = function (oImgData) {
    window.halt_global_keyDown = false

    this.abortInlineEmotePreviewLookup()

    if (this.oTextInput) {
        this.oTextInput.removeEventListener('keydown', this.keyHandler_bound)
    }

    if (this.oPreviewDiv && this.oPreviewDiv.parentNode) {
        this.oPreviewDiv.parentNode.removeChild(this.oPreviewDiv)
    }
}

ParseEmoteInput.prototype.inlineEmotePreview_select = function (
    sShortcut,
    sExisting,
    hOpts,
) {
    hOpts = hOpts || {}
    if (!sExisting) {
        const oMatch = this.oTextInput.value.match(/:(\w+)\W*$/)
        sExisting = oMatch[1]
    }
    const nextValue =
        this.oTextInput.value.replace(sExisting, sShortcut) +
        (hOpts.no_space ? '' : ' ')
    if (this.setComposeMessage) this.setComposeMessage(nextValue)
    this.oTextInput.focus()
    this.inlineEmotePreview_close()
}

ParseEmoteInput.prototype.keyHandler = function (e, caller) {
    window.halt_global_keyDown = true

    // tab key
    if (e.which == 9) {
        e.preventDefault()
        this.inlineEmotePreview_select(this.inlineEmotePreview_selectedShortcut)
    }

    // enter key
    else if (e.which == 13 && this.inlineEmotePreview_arrowKeyWasPressed) {
        e.preventDefault()
        this.inlineEmotePreview_select(this.inlineEmotePreview_selectedShortcut)
    }

    // escape key
    else if (e.which == 27) {
        this.inlineEmotePreview_close()
    }

    // right-key
    else if (e.which == 39) {
        e.preventDefault()
        this.inlineEmotePreview_select(
            this.inlineEmotePreview_selectedShortcut,
            null,
            { no_space: true },
        )
    }

    // up-key
    else if (e.which == 38) {
        e.preventDefault()
        this.inlineEmotePreview_selected =
            this.inlineEmotePreview_selected > 0
                ? this.inlineEmotePreview_selected - 1
                : 0
        this.inlineEmotePreview_setSelected(this.inlineEmotePreview_selected)
        this.inlineEmotePreview_arrowKeyWasPressed = true
    }

    // down-key
    else if (e.which == 40) {
        e.preventDefault()
        this.inlineEmotePreview_selected =
            this.inlineEmotePreview_selected <
            this.inlineEmotePreview_listLength - 1
                ? this.inlineEmotePreview_selected + 1
                : this.inlineEmotePreview_listLength - 1
        this.inlineEmotePreview_setSelected(this.inlineEmotePreview_selected)
        this.inlineEmotePreview_arrowKeyWasPressed = true
    } else {
        this.inlineEmotePreview_close()
    }
}

ParseEmoteInput.prototype.inlineEmotePreview_setSelected = function (selected) {
    var els = document.getElementsByClassName('inlineEmotePreview_item')

    this.inlineEmotePreview_selectedShortcut =
        this.inlineEmotePreview_list[selected]
    for (var a = 0; a < els.length; a++) {
        if (a == selected) els[a].classList.add('selected')
        else els[a].classList.remove('selected')
    }

    this.oPreviewDiv.scrollTop =
        els[selected].offsetTop - this.oPreviewDiv.offsetHeight / 2 + 20
}

ParseEmoteInput.prototype.inlineEmotePreview_renderPreviewImage = function (
    oImgData,
) {
    var oPreviewDiv = this.oPreviewDiv

    //  exit early if the input value is unchanged
    if (this.inlineEmotePreview_inputString == this.oTextInput.value) {
        return
    }
    this.inlineEmotePreview_inputString = this.oTextInput.value

    if (!oImgData || (!oImgData.url && !oImgData.partials)) {
        this.inlineEmotePreview_close()
        return
    }

    this.inlineEmotePreview_list = []
    this.inlineEmotePreview_selected = 0
    this.inlineEmotePreview_arrowKeyWasPressed = false

    var self = this

    if (!this.keyHandler_bound) {
        this.keyHandler_bound = function (e) {
            self.keyHandler(e)
        }
    }
    this.oTextInput.removeEventListener('keydown', this.keyHandler_bound)
    this.oTextInput.addEventListener('keydown', this.keyHandler_bound)

    this.oImgData = oImgData

    if (!oPreviewDiv) {
        oPreviewDiv = document.createElement('div')
        this.oPreviewDiv = oPreviewDiv
    }

    var previews = []
    if (oImgData.url) {
        this.inlineEmotePreview_list.push(oImgData.shortcut)
        previews.push(
            '<div class="inlineEmotePreview_item primary"><img src=' +
                oImgData.url +
                ' > :' +
                oImgData.shortcut +
                '</div>',
        )
    }

    if (oImgData.partials) {
        for (let a = 0; a < oImgData.partials.length; a++) {
            const hPartial = oImgData.partials[a]
            this.inlineEmotePreview_list.push(hPartial.shortcut)
            const url =
                this.image_url +
                'chat_images/u/' +
                hPartial['hex_crc32'].substring(0, 2) +
                '/' +
                hPartial['hex_crc32'] +
                '.' +
                hPartial['format']
            previews.push(
                '\
				<div class="inlineEmotePreview_item partial"\
					onClick="ParseEmoteInput.register[' +
                    this.counter +
                    "].inlineEmotePreview_select('" +
                    hPartial.shortcut +
                    "','" +
                    (oImgData.shortcut || '') +
                    '\'); ">\
				 <img src=' +
                    url +
                    ' >\
				 <div style="display:inline-block;">\
					:' +
                    hPartial.shortcut +
                    '\
				 </div>\
				</div>\
			',
            )
        }
    }

    if (this.inlineEmotePreview_list[0]) {
        this.inlineEmotePreview_selectedShortcut =
            this.inlineEmotePreview_list[0]
    }

    var html = '<div>' + previews.join('') + '</div>'

    this.inlineEmotePreview_listLength = this.inlineEmotePreview_list.length

    oPreviewDiv.className = 'inlineEmotePreview_div'
    oPreviewDiv.style.position = 'absolute'

    // custom anchor for APP MFC
    const oAnchor = this.oAnchor || 'top'
    applyCustomPreviewDivStyles(oPreviewDiv, oAnchor)

    oPreviewDiv.innerHTML = html

    this.oTextInput.parentNode.appendChild(oPreviewDiv)

    this.inlineEmotePreview_setSelected(0)
}

if (typeof window !== 'undefined') {
    window.ParseEmoteInput = ParseEmoteInput
}

export { ParseEmoteInput }
